import React, { useEffect, useState } from "react";
import styles from "./MobileAsidebarNavigation.module.css";

import { ReactComponent as ChatIcon } from "../../../assets/chatBlack.svg";
import { ReactComponent as PanelMobileIcon } from "../../../assets/panelBlack.svg";
import { ReactComponent as BoxIcon } from "../../../assets/assetsBlack.svg";
import { ReactComponent as DotsNotification } from "../../../assets/dotsNotificationBlack.svg";
import { ReactComponent as ClientIcon } from "../../../assets/contactsBlack.svg";
import { ReactComponent as SettingBlackIcon } from "../../../assets/SettingBlackIcon.svg";
import { ReactComponent as DashboardBlackIcon } from "../../../assets/DashboardBlackIcon.svg";
import { ReactComponent as StarPlus } from "../../../assets/starPlus.svg";
import { ReactComponent as LogoutBlackIcon } from "../../../assets/LogoutBlackIcon.svg";
import { ReactComponent as GptsBlackIcon } from "../../../assets/GptsBlackIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import GetPlusButton from "../../GetPlusButton/GetPlusButton.jsx";
import { ReactComponent as Plusgreen } from "../../../assets/plusIconGreen2.svg";
import { useTranslation } from "react-i18next";
import { MdDarkMode, MdLightMode } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { setTheme } from "../../../../../slices/themeSlices.js";
import {createVariable} from "../../../../../actions/user";

const MobileAsidebarNavigation = ({
  menuOpen,
  setMenuOpen,
  menuOpenChat,
  setMenuOpenChat,
  fromPath,
  setShowPlusModal,
  setIsOpen,
  setShowOptions,
  setShowSidebar
}) => {
  const { t } = useTranslation("navbarAdmin");
  const { theme } = useSelector((state) => state.theme);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [numNotification, setNumNotification] = useState(0);

  const { user } = useSelector((state) => state.user);
  const [clickCount, setClickCount] = useState(0);
  const [clickTimer, setClickTimer] = useState(null);
  const [imageError, setImageError] = useState(false);
  const [showSetting, setShowSetting] = useState(false);
  const handleProfileClick = () => {
  setShowSetting((prev) => !prev)

  };
  const [showCorporativeModal, setShowCorporativeModal] = useState(false);
  const [corporativeTitle, setCorporativeTitle] = useState("");
  const [corporativeMessage, setCorporativeMessage] = useState("");
  const [logout, setLogout] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);

  useEffect(() => {
    if (logout) {
      localStorage.clear();
      navigate("/login");
    }
  }, [logout]);

  const handleLogOut = () => {
    setShowCorporativeModal(true);
    setCorporativeTitle(t("logout"));
    setCorporativeMessage(t("areYouSureLogout"));
  };


  const onToggleTheme = async (theme) => {
    try {
      dispatch(setTheme(theme));
      localStorage.setItem('theme', theme);
      const data = await dispatch(createVariable({ variableData: { type: "theme", title: "theme", description:theme } }));
    }catch (e) {
      console.log("Error setting theme:", e);
    }
  }

  return (
    <>
      <div
        className={`${styles.mobileMenuOverlay} ${(menuOpen && styles.activeMenuOverlay) || (menuOpenChat && styles.activeMenuOverlay)} `}
        onClick={() => {
          setMenuOpenChat !== undefined && setMenuOpenChat(false);
          setMenuOpen(false);
        }}
      ></div>
      <div
        className={`${styles.mobileMenu} ${(menuOpen && styles.activeMobileMenu) || (menuOpenChat && styles.activeMobileMenu)}`}
      >
        <ul>
          <li>
            {" "}
            <div
              onClick={handleProfileClick}
              className={styles.profileContainer}
            >
              {user?.profileImage && !imageError ? (
                <img
                  className={styles.profileImage}
                  src={user.profileImage}
                  alt={t('userProfilePicture')}
                  onError={() => setImageError(true)}
                />
              ) : (
                <div className={styles.initials}>
                  {user?.nombre?.split(" ").map((word) => word[0] || "U")}
                </div>
              )}
              <div className={styles.profileText}>
                {user?.nombre?.length >= 20 && <p className={styles.pWithTooltip} data-tooltip={user?.nombre}>{`${user?.nombre.slice(0, 19)}..`}</p>}
                {user?.nombre?.length <= 19 && <p>{user?.nombre || t("noFound")}</p>}
                <span>{user?.role || t('noFound')}</span>
              </div>
            </div>
          </li>
          <li>
            <a
              href="/admin/chat"
              className={`${fromPath == "chat" ? styles.active : ""} ${styles.bigger}`}
            >
              <div className={styles.svgContainer}>
                <ChatIcon />
              </div>
              {t('chat')}
            </a>
          </li>
          <li>
            <a
              href="/admin/panel"
              className={fromPath == "panel" ? styles.active : ""}
            >
              <div className={styles.svgContainer}>
                <PanelMobileIcon />
              </div>
              {t('panel')}
            </a>
          </li>
        
          <li>
            <a
              href="/admin/contacts"
              className={`${fromPath == "contacts" ? styles.active : ""} ${styles.bigger}`}
            >
              <div className={styles.svgContainer}>
                <ClientIcon />
              </div>
              {t('contacts')}
            </a>
          </li>{" "}
          <li>
            <a
              href="/admin/assets"
              className={`${fromPath == "assets" ? styles.active : ""} ${styles.bigger}`}
            >
              <div className={styles.svgContainer}>
                <BoxIcon />
              </div>
              {t('assets ')}
            </a>
          </li>{" "}
          <li>
            <a
              href="/admin/notification"
              className={`${styles.number} 
          ${fromPath == "notification" ? styles.active : ""} ${styles.bigger}`}
            >
              <div className={styles.svgContainer}>
                <DotsNotification />
              </div>
              {t('notifications')}
              {numNotification !== 0 && <span>{numNotification}</span>}
            </a>
          </li>

          <li>
            {" "}

            <div className={styles.fileExplorerGetPlusContainer}>
            {user?.payMethod?.length == 0 ? (
              <GetPlusButton
                action={() => {
                  setMenuOpen(false);
                  setShowPlusModal(true);
                }}
              />
                  ) :
                  <></>}
              <div
                className={styles.moreGreen}
                onClick={() => {
                  setMenuOpen(false);
                  setIsOpen(true);
                }}
              >
                <Plusgreen />
              </div>
            </div>


          </li>
        </ul>
        {
          showSetting && (
            <div className={styles.options}>
                  <ul>
                    <li
                      onClick={() => {
                        setMenuOpen(false);
                        setShowSidebar(true);
                      }}
                    >
                      <SettingBlackIcon /> {t("setting")}
                    </li>
                    <li onClick={() => navigate("/admin/home")}>
                      <DashboardBlackIcon /> {t("dashboard")}
                    </li>
                    <li
                      onClick={() =>{
                        navigate(`/admin/agent`)
                        }
                      }
                    >
                      <GptsBlackIcon /> {t("gpts")}
                    </li>
                    <li
                      className={styles.upgradePlan}
                      onClick={() => {
                        setMenuOpen(false);
                        setShowPlusModal(true);
                      }}
                    >
                      <StarPlus /> {t("upgradePlan")}
                    </li>
                   {theme === 'dark' ? (
                              <li onClick={() => onToggleTheme('light')}>
                                <MdLightMode size={18} /> {t("lightMode")}
                              </li>
                            ) : (
                              <li onClick={() => onToggleTheme('dark')}>
                                <MdDarkMode size={18} />
                                {t("darkMode")}
                              </li>
                            )}
                    <li onClick={handleLogOut}>
                      <LogoutBlackIcon /> {t("LogOut")}
                    </li>
                  </ul>
                </div>
            )
          }
      </div>
    </>
  );
};

export default MobileAsidebarNavigation;
